"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShareMenuModule = /** @class */ (function () {
    function ShareMenuModule() {
    }
    return ShareMenuModule;
}());
exports.ShareMenuModule = ShareMenuModule;
